import { render, staticRenderFns } from "./main-solution.vue?vue&type=template&id=6fc4ba9a&scoped=true&"
import script from "./main-solution.vue?vue&type=script&lang=js&"
export * from "./main-solution.vue?vue&type=script&lang=js&"
import style0 from "./main-solution.vue?vue&type=style&index=0&id=6fc4ba9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc4ba9a",
  null
  
)

export default component.exports